import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

export interface ICloneQbrDocumentParameters {
  documentId: number
  name: string
}

export const cloneQbrDocument = async ({ documentId, name }: ICloneQbrDocumentParameters) => {
  const url = proxy(`/webservice/197/sp/v4/spJBPQBRDocumentClone/call`)

  const payload = {
    'p.EntryId': documentId,
    'p.Name': name,
  }

  const {
    app: { ownerId },
  } = appGetState()

  const [accessToken] = getTokens(ownerId)
  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  try {
    const response = await Rest.post({ url, payload, headers })

    return response.Data?.[0] || null
  } catch (e) {
    return null
  }
}
